'use client';

import { useEffect } from 'react';
import { installGlobalErrorReporter } from '@/lib/platform/clientLogger';

export function ClientErrorReporter() {
  useEffect(() => {
    installGlobalErrorReporter();
  }, []);
  return null;
}
